'use client';

import { FC, PropsWithChildren } from 'react';

import GeneralSkeleton from '@/components/skeletons/GeneralSkeleton';
import { useCommonStore } from '@/store';

interface MobileAppLayoutProps extends PropsWithChildren {}

const MobileAppLayout: FC<MobileAppLayoutProps> = ({ children }) => {
  const mobileAppCMSPending = useCommonStore.use.mobileAppCMSPending();
  if (mobileAppCMSPending) return <GeneralSkeleton />;
  return children;
};

export default MobileAppLayout;
